import { useState } from 'react'
import { Alert, AlertColor, AlertTitle, Box, Button, Grid2, Snackbar, Step, StepLabel, Stepper, Typography } from '@mui/material'
import { isEmpty } from 'lodash/fp'
import { sendRequestData } from './function'
import log from 'loglevel'
import { FormInput } from '../../types'
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { FormInputSchema } from '../../functions/schema'
import InputForm from '../InputForm'
import { useFormStore } from '../../functions/formStore'
import alertPropaties from './alert-propaties.json'
import { ThanksPage } from '../ThanksPage'
import Confirm from '../Confirm'


log.setLevel(log.levels.DEBUG)

const buttonNames = {
    next: "次へ",
    back: "戻る",
    submit: "送信"
}

enum ActiveSteps {
    form = 0,
    confirm = 1,
    complete = 2
}


export const FormProgress = () => {
    const [activeStep, setActiveStep] = useState<number>(0)
    const [alertStatus, setAlertStatus] = useState<AlertColor | undefined>(undefined)
    const [isSending, setIsSending] = useState<boolean>(false)
    const { data } = useFormStore()



    const methods = useForm<FormInput>({
        resolver: zodResolver(FormInputSchema),
        defaultValues: {
            No1: undefined,
            No2: undefined,
            No3: "",
            No4: "",
            No5: undefined,
            No6: "",
            No7: "",
            No8: "",
            No9: "",
            No10: "",
            No11: "",
            No12: undefined,
            No13: undefined,
            No14: "",
            No15: undefined,
        },
        mode: 'onSubmit'
    })
    const { handleSubmit } = methods

    const contentArray = [
        <InputForm />,
        <Confirm />
    ]
    const contentNameArray = [
        "入力画面",
        "ご確認画面",
        "完了"
    ]
    const onSubmit: SubmitHandler<FormInput> = (_data) => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1)
    }

    const handleNext = () => {
        setIsSending(true)
        if (activeStep === ActiveSteps.form) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1)
            setIsSending(false)
        }
        if (activeStep === ActiveSteps.confirm) {
            sendRequestData(data).then((result) => {
                setIsSending(false)
                result ? setActiveStep((prevActiveStep) => prevActiveStep + 1) : setAlertStatus("error")
            })
        }
    }
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1)
    }

    const handleAlertClose = () => {
        setAlertStatus(undefined)
    }

    const getStepContent = (
        stepIndex: number,
        contentArray: Array<JSX.Element>
    ): JSX.Element | undefined => {
        return stepIndex >= contentArray.length ? undefined : contentArray[stepIndex]
    }

    return (
        <Grid2 container>
            <Grid2 size={{ sm: 2 }} />
            <Grid2 size={{ lg: 8, sm: 8 }} spacing={10}>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {contentNameArray.map((name) => (
                        <Step key={name}>
                            <StepLabel>{name}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                {activeStep === contentArray.length ? (
                    <Box>
                        {<ThanksPage />}
                    </Box>
                ) : (
                    <Box>
                        <Typography ><FormProvider {...methods}>{getStepContent(activeStep, contentArray)}</FormProvider></Typography>
                        <Box display={"flex"} justifyContent={"space-around"} paddingTop={3}>
                            <Box justifyContent={"start"}>
                                <Button variant="outlined"
                                    disabled={activeStep === 0}
                                    onClick={handleBack}
                                >
                                    {buttonNames.back}
                                </Button>
                            </Box>
                            <Box justifyContent={"end"}>
                                <Button variant="contained" color="primary" onClick={activeStep === ActiveSteps.form ? handleSubmit(onSubmit) : handleNext} disabled={isSending}>
                                    {activeStep === ActiveSteps.confirm ? buttonNames.submit : buttonNames.next}
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                )}
            </Grid2>
            <Snackbar open={!isEmpty(alertStatus)} autoHideDuration={5000} onClose={handleAlertClose}>
                <Alert severity={alertStatus}>
                    <AlertTitle>{!isEmpty(alertStatus) ? alertPropaties[alertStatus as keyof typeof alertPropaties]["alertTitle"] : ""}</AlertTitle>
                    {!isEmpty(alertStatus) ? alertPropaties[alertStatus as keyof typeof alertPropaties]["alertMessage"] : ""}
                </Alert>
            </Snackbar>
        </Grid2>
    )
}

export default FormProgress